import { render, staticRenderFns } from "./ModalRefuseProposal.vue?vue&type=template&id=63e84356"
import script from "./ModalRefuseProposal.vue?vue&type=script&lang=js"
export * from "./ModalRefuseProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports